import { FORM_LIMIT } from '@/shared/constants/forms';

// Match the App knowledge endpoint's question contract.
export const askKnowledgeSchema = {
  type: 'object',
  required: ['question'],
  properties: {
    question: {
      type: 'string',
      minLength: 1,
      maxLength: FORM_LIMIT.CHAT,
      pattern: '\\S',
      errorMessage: {
        required: 'nkf.required',
        minLength: 'nkf.required',
        pattern: 'nkf.required',
        maxLength: 'shared.validation.max_length',
      },
    },
  },
  additionalProperties: false,
};
